/**
 * Socket 'connectToUyap' olayının yükü (DEV-3898).
 *
 * Kabuk (2.0.5) yükü yalnız `{kaynak}` olarak iletir. İki değer:
 *  - 'kurtarma': istek bot döngüsünden (kimse başında değil); imzacı SESSİZ
 *    `tarayiciKurtarmasiniSurdur`u çalıştırır (bağlı bayrağı bayatsa önce oturumu canlı doğrular,
 *    gerekirse `botBaglantisiniSurdur`a ilerler), PIN penceresi açılmaz;
 *  - 'kurtarma-arayuz' ve YÜKSÜZ olay (icrapro-app düğmeleri, eski kabuklar): eskisi gibi
 *    GÖRÜNÜR giriş (PIN penceresi açılabilir; kullanıcı bekliyor).
 *
 * Saf tutuldu ki bileşen mount etmeden test edilebilsin (repo deseni).
 */
export function baglantiOlayiSessizMi(yuk: unknown): boolean {
    return !!yuk && typeof yuk === 'object' && (yuk as {kaynak?: unknown}).kaynak === 'kurtarma';
}
